import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/TermsAndConditions.css'; // Import your CSS

const TermsAndConditions = () => {
  return (
    <section className="terms-section">
    <div className="terms-policy-container">
      <h1 className="terms-title">Terms & Conditions</h1>
      <p className="terms-updated">Updated: {new Date().toDateString()}</p>

      <div className="terms-content">
        <p>
          Welcome to Growth Labs! By accessing or using our website and services, you agree to these Terms and Conditions ("Terms"). Please read them carefully before engaging with our services.
          If you do not agree with these Terms, you must discontinue use of our website.
        </p>

        <h2>1. Definitions</h2>
        <ul>
          <li>"We," "us," "our": Refers to Growth Labs, its affiliates, and representatives.</li>
          <li>"You," "your": Refers to the user, client, or visitor accessing our website or services.</li>
          <li>"Services": Refers to the digital marketing services and resources provided by Growth Labs.</li>
        </ul>

        <h2>2. Use of Our Website and Services</h2>
        <p>You agree to:</p>
        <ul>
          <li>Use our website and services for lawful purposes only.</li>
          <li>Not engage in any activity that disrupts or interferes with our website or its security.</li>
          <li>Provide accurate information when interacting with us or using our services.</li>
        </ul>
        <p>We reserve the right to restrict or terminate your access to our website or services if you violate these Terms.</p>

        <h2>3. Intellectual Property</h2>
        <p>All content on this website, including text, images, logos, graphics, and software, 
            is owned by or licensed to Growth Labs and is protected under applicable intellectual property laws. You may not reproduce, distribute, or use any content without prior written consent from Growth Labs.</p>

        <h2>4. Disclaimer of Warranties</h2>
        <p>Our website and services are provided "as is" and "as available" without warranties of any kind, either express or implied. We do not guarantee that:</p>
        <ul>
          <li>Our services will meet your specific needs or expectations.</li>
          <li>The website will operate uninterrupted, secure, or error-free.</li>
        </ul>

        <h2>5. Limitation of Liability</h2>
        <p>To the fullest extent permitted by law, Growth Labs shall not be liable for any indirect, incidental, or consequential damages arising from:</p>
        <ul>
          <li>Your use or inability to use our website or services.</li>
          <li>Errors or omissions in content.</li>
          <li>Unauthorized access to or misuse of your data.</li>
        </ul>
        <p>Our total liability is limited to the amount paid by you (if any) for the services in question.</p>

        <h2>6. Payment Terms</h2>
        <p>If you engage Growth Labs for services:</p>
        <ul>
            <li>Payment is due as outlined in your agreement with us.</li>
            <li>Late payments may result in suspension or termination of services.</li>
            <li>You are responsible for all applicable taxes, fees, or charges associated with the services.</li>
        </ul>

        <h2>7. Third-Party Links and Tools</h2>
        <p>Our website may include links to third-party websites or tools. Growth Labs is not responsible for the accuracy, functionality, or practices of these third-party services. You use these links and tools at your own risk.</p>

        <h2>8. Termination</h2>
        <p>We reserve the right to terminate or suspend your access to our website or services at our discretion, without notice, for any violation of these Terms or other harmful conduct.</p>

        <h2>9. Governing Law</h2>
        <p>These Terms are governed by and construed in accordance with the laws of Utah. Any disputes arising under these Terms shall be subject to the exclusive jurisdiction of the courts in Utah.</p>

        <h2>10. Changes to These Terms</h2>
        <p>We may update these Terms from time to time to reflect changes in our practices or applicable laws. Any updates will be posted on this page with a revised effective date. Continued use of our website after updates constitutes acceptance of the revised Terms.</p>

        <h2>11. Contact Us</h2>
        <p>If you have questions or concerns about these Terms, please contact us:</p>
        <p>Growth Labs</p>
        <p>Email: <strong>mandy@growthlabadvertising.com</strong></p>
      </div>

      <p>By using our website and services, you acknowledge that you have read, understood, and agree to these Terms and Conditions.</p>

      <div className="back-to-home">
        <Link to="/">
          <button className="home-button">Back To Home</button>
        </Link>
      </div>
    </div>
    </section>
  );
};

export default TermsAndConditions;